var _defs, _g, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCurveBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1317.04 338.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #444;\n      }\n\n      .cls-2 {\n        fill: #aaa;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M455.8,225.64l-54.63,25.52c4.79,5.11,8.01,11.71,8.89,19.03l54.63-25.52c-4.79-5.11-8.01-11.71-8.89-19.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M346.39,289.49c-2.32-4.58-3.63-9.75-3.63-15.23,0-1.88.16-3.73.46-5.53l-49.33,7.54c2.32,4.58,3.63,9.75,3.63,15.23,0,1.88-.16,3.73-.46,5.53l49.33-7.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M232.18,303.56c-1.43-3.74-2.22-7.8-2.22-12.05,0-3.09.42-6.08,1.2-8.93l-48.66,2.37c1.43,3.74,2.22,7.8,2.22,12.05,0,3.09-.42,6.08-1.2,8.92l48.66-2.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M569.74,153.16l-59.99,41.51c5.64,4.29,9.88,10.31,11.95,17.27l59.99-41.51c-5.64-4.29-9.88-10.31-11.95-17.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M119.2,308.56c-1.31-3.61-2.03-7.5-2.03-11.56,0-3.27.47-6.43,1.34-9.43l-48.61,1.62c1.31,3.61,2.03,7.5,2.03,11.56,0,3.27-.47,6.43-1.34,9.43l48.61-1.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1031.64,116.63l-58.34-36.46c-1.74,7.08-5.72,13.27-11.13,17.8l58.35,36.46c1.74-7.07,5.71-13.27,11.13-17.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M682.15,80.77l-58.45,36.78c5.43,4.52,9.42,10.7,11.19,17.77l58.45-36.78c-5.43-4.52-9.42-10.7-11.19-17.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1145.59,193.25l-59.89-41.17c-2.05,6.97-6.28,13-11.9,17.3l59.89,41.17c2.05-6.97,6.28-13,11.9-17.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1254.17,249.28l-54.54-25.24c-.85,7.33-4.05,13.93-8.82,19.06l54.54,25.24c.85-7.33,4.05-13.93,8.82-19.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M906.75,72.88c0-.27-.02-.54-.02-.81,0-7.18,2.25-13.83,6.06-19.3l-51.32-15.43c0,.27.02.54.02.81,0,7.18-2.24,13.83-6.06,19.3l51.32,15.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M800.07,57.56c-3.86-5.49-6.14-12.18-6.14-19.41,0-.23.01-.45.02-.68l-51.4,15.68c3.86,5.49,6.14,12.18,6.14,19.41,0,.23-.01.45-.02.68l51.4-15.68Z"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 38.15,
    cy: 300.75,
    r: 28.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 150.94,
    cy: 297,
    r: 28.15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1166.09,
    cy: 220.09,
    r: 28.15
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1053.3,
    cy: 142.54,
    r: 28.15
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 940.51,
    cy: 72.06,
    r: 28.15
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 827.71,
    cy: 38.15,
    r: 28.15
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 714.92,
    cy: 72.56,
    r: 28.15
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 602.12,
    cy: 143.53,
    r: 28.15
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 489.33,
    cy: 221.57,
    r: 28.15
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 376.53,
    cy: 274.26,
    r: 28.15
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 263.74,
    cy: 291.51,
    r: 28.15
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 1278.89,
    cy: 272.28,
    r: 28.15
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurveBell);
export default __webpack_public_path__ + "static/media/curve_bell.1128d6b0.svg";
export { ForwardRef as ReactComponent };